interface UserRole {
  hospital: string;
  department: string;
  role: 'USER' | 'EDITOR' | 'ADMIN';
}

interface User {
  _id: string;
  isSuperAdmin?: boolean;
  roles?: UserRole[];
}

interface CaseItem {
  createdBy?: { _id: string };
  department?: { _id: string } | string;
}

export const canUserEditCase = (user: User | null | undefined, caseItem: CaseItem | null | undefined): boolean => {
  if (!user || !caseItem) {
    return false;
  }

  if (user.isSuperAdmin) {
    return true;
  }

  if (caseItem.createdBy && caseItem.createdBy._id === user._id) {
    return true;
  }

  const caseDepartmentId = typeof caseItem.department === 'string' ? caseItem.department : caseItem.department?._id;
  if (!caseDepartmentId) {
    return false;
  }

  return user.roles?.some(
    (role) =>
      role.department === caseDepartmentId &&
      ['EDITOR', 'ADMIN'].includes(role.role)
  ) || false;
};
